import React from "react";

const Logo = (props) => {
  return (
    <img
      src="/images/Mobiloitte_blue_logo.png"
      onDragStart={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
      alt="Logo"
      {...props}
      style={{ maxWidth: "179px", margin: "0 auto" }} //here was not style css
    />
  );
};

export default Logo;
